<template>
    <div>
        <h5 class="ml-3 text-uppercase font-weight-bold ">Assessments</h5>
        <div class="widget p-3">
            <polar-area-chart
                :height="200"
                :width="280"
                :data="polarAreaChart()"
                :options="{
                    legend: { display: false },
                    position: 'top',
                    layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
                    responsive: true,
                    maintainAspectRatio: false,
                    scale: {
                        gridLines: {
                            color: '#ffffff',
                            drawOnChartArea: true,
                        },
                        ticks: {
                            display: false,
                            min: 0,
                            max: 6,
                            fontColor: 'transparent',
                        },
                    },
                }"
                >></polar-area-chart
            >
        </div>
    </div>
</template>

<script>
import PolarAreaChart from "./PolarAreaChart";
export default {
    name: "PatientAssessment",
    components: { PolarAreaChart },
    data() {
        return {
            labels: [],
            data: [3, 1, 3, 2, 2, 4, 2, 4, 6, 4, 6, 3, 5, 1, 2, 5, 6, 3, 4, 6, 1, 2, 5],
        };
    },
    created() {},
    methods: {
        polarAreaChart() {
            return {
                labels: this.labels,
                datasets: [
                    {
                        backgroundColor: [
                            "#B7DD35",
                            "#A1D00E",
                            "#77C431",
                            "#4DB549",
                            "#FCDB6A",
                            "#FACB5D",
                            "#F9B527",
                            "#F6AF1D",
                            "#F69E11",
                            "#F86378",
                            "#F34C5E",
                            "#E52A40",
                            "#D7051E",
                            "#560082",
                            "#7F00AD",
                            "#8000B0",
                            "#B651EA",
                            "#1A4C87",
                            "#2675BB",
                            "#4CC1CB",
                            "#4DD0E2",
                            "#60E6EC",
                            "#85EDFA",
                        ],
                        borderColor: "rgba(255,255,255,0.3)",
                        borderWidth: 2,
                        data: this.data,
                    },
                ],
            };
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
